import mask from 'jquery-mask-plugin'

/*
    SUMMARY
    0 - Functions
    1 - Mask Inputs
        1.1 - FORMATERS
        1.2 - PHONES
    2 - Form

*/



export default function contactForm(){
    /*----------------------- 0 - Functions ---------------------------*/
    const regex = /[0-9]/;

    function showMessageError(id, emailAlreadExist = false){
        const element = document.getElementById(id)
        const fatherEl = element.parentNode
        if(emailAlreadExist){
            fatherEl.classList.add("error--message--emailAlreadExist")
        }else{
            fatherEl.classList.add("error--message")
        }
    }
    
    function removeAllError(){
        const inputGroup = document.querySelectorAll(".group--input")
        inputGroup.forEach( group => {
            group.classList.remove("error--message")
            group.classList.remove("error--message--emailAlreadExist")
        })
    }

    /*----------------------- 1 - Mask Inputs ---------------------------*/
    // 1.1 - FORMATERS
    const formaterNumber = '(00) 00000-0000'


    // 1.2 - PHONES
    const numberValidation = formaterNumber.length
    $("#ct-phone").mask(formaterNumber)

     /*----------------------- 2 - Mask Inputs ---------------------------*/
    $("#contact-form").on('submit', function (e) {
        removeAllError()

        e.preventDefault();
        var email = $("#ct-email").val();
        var name = $("#ct-name").val();
        let phone = $("#ct-phone").val();
        let subject = $("#ct-subject").val();
        let message = $("#ct-message").val();

        function isValidEmail(emailAddress) {
            var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
            return pattern.test(emailAddress);
        };

        let error = false;

        function checkEmailExist() {
            let urlEmail = $('#emailCheck').val();
    
            $.ajax({
                type: "POST",
                url: urlEmail,
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                data: 'email=' + $("#ct-email").val(),
                dataType: 'json',
                success: function (json) {
                    if (json.status) {
                        error = true;
                        showMessageError('ct-email', true);
                    }
                }
            });
    
        }
        
        if ((!name || regex.test(name)) && !error ) {
            error = true;
            showMessageError('ct-name')
        }

        if (isValidEmail(email) == false && !error) {
            error = true;
            showMessageError('ct-email')
        }

        if (!error) {
            checkEmailExist();
        }


        if (!subject && !error) {
            error = true;
            showMessageError('ct-subject')
        }

        if(!phone && !error || phone.length !== numberValidation && !error) {
            error = true;
            showMessageError('ct-phone')
        }

        if (!message && !error) {
            error = true;
            showMessageError('ct-message')
        }

        var url = $(this).attr('action');

        if (!error) {
            grecaptcha.ready(function () {
                grecaptcha.execute($("#recaptcha").val(), {
                  action: 'submit'
                }).then(function (token) {
                    var dataString = 'name=' + name + '&email=' + email + '&phone=' + phone + '&subject=' + subject + '&message=' + message + '&gRecaptchaResponse='+ token;
                    $.ajax({
                        type: "POST",
                        url: url,
                        headers: {
                        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                        },
                        data: dataString,
                        dataType: 'json',
                        success: function (json) {
                            if (json.status == true) {
                                $('.success-message').html( "<div><i class='fa-solid fa-circle-check'></i> <span>Seu cadastro foi realizado<br><b>com sucesso!</b></span></div>" );
                                $("#ct-email").val('');
                                $("#ct-name").val('');
                                $("#ct-phone").val('');
                                $("#ct-subject").val('');
                                $("#ct-message").val('');
                                $('.success-message').fadeIn(3000, () => {
                                    $('.success-message').fadeOut(3000);
                                });
                                $('.fail-message').fadeOut(3000);
                            } else {
                                $('.fail-message').html( `<div class='danger-box'><i class='fa-solid fa-circle-xmark'></i> ${json.txt} </div>` );
                                $('.fail-message').fadeIn(3000, () => {
                                    $('.fail-message').fadeOut(3000);
                                });
                                $('.success-message').fadeOut(3000);
                            }
                        }
                    });
                });
            });
        }
        else {
            $('.fail-message').fadeIn(3000, () => {
                $('.fail-message').fadeOut(3000);
            });
            $('.success-message').fadeOut(3000);
        }
        return false;
      });
    }
